// 在Vue3中，我们使用mitt作为事件总线
import mitt from "mitt";

const emitter = mitt();

// 为了保持API兼容性，我们创建一个类似Vue实例的接口
const bus = {
  $on: (event, handler) => emitter.on(event, handler),
  $emit: (event, ...args) => emitter.emit(event, ...args),
  $off: (event, handler) => emitter.off(event, handler),
  // 添加mitt的原生方法
  on: emitter.on,
  emit: emitter.emit,
  off: emitter.off,
};

export { bus as default, bus as $$VueBus };
